import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { GuaranteeNotes } from "@app/models/guarantee-notes";
import { GuaranteeAgreementNotesService } from "@app/services/guarantee-agreement-notes.service";

@Component({
    selector: "app-guarantee-note-node",
    templateUrl: "./guarantee-note-node.component.html",
    styleUrls: ["./guarantee-note-node.component.css"],
    standalone: false
})
export class GuaranteeNoteNodeComponent implements OnInit {
  @Input() level: number;
  @Input() guaranteeNotes: Array<GuaranteeNotes>;
  @Input() selectedGuaranteeNotes: Array<GuaranteeNotes>;
  @Output() onAddGuaranteeNote = new EventEmitter<GuaranteeNotes>();
  @Output() onDeleteGuaranteeNote = new EventEmitter<GuaranteeNotes>();

  constructor(private guaranteeNotesService: GuaranteeAgreementNotesService) {}

  ngOnInit(): void {}

  changeNoteStatus(item, value) {
    if (value.target.checked) {
      this.addGuaranteeNote(item);
    } else {
      this.deleteGuaranteeNote(item);
    }
  }

  addGuaranteeNote(item) {
    this.onAddGuaranteeNote.emit(item);
  }

  deleteGuaranteeNote(item) {
    this.onDeleteGuaranteeNote.emit(item);
  }

  isSelectedGuaranteeNote(item: GuaranteeNotes): boolean {
    if (!this.selectedGuaranteeNotes || !item) {
      return false;
    }
    return this.selectedGuaranteeNotes.some((p) => p && p.id === item.id);
  }

  isIndeterminate(item: GuaranteeNotes): boolean {
    return !!item?.subGuaranteeNotes?.length && !this.isSelectedGuaranteeNote(item)
      && item.subGuaranteeNotes.some((child) => this.isSelectedGuaranteeNote(child) || this.hasSelectedDescendant(child));
  }

  isExpanded(item: GuaranteeNotes): boolean {
    return this.isSelectedGuaranteeNote(item) || this.hasSelectedDescendant(item);
  }

  private hasSelectedDescendant(item: GuaranteeNotes): boolean {
    return !!item?.subGuaranteeNotes?.some((child) => this.isSelectedGuaranteeNote(child) || this.hasSelectedDescendant(child));
  }
}
